import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../../../components/api';

export interface UserListData {
  position: string,
  name: string,
  email: string,
  id: string,
}

function useUsers() {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Navigate Handler
  */
  const navigate = useNavigate();
  // Navigate to Landing Page
  const onNavigateBack = () => navigate('/user-management');
  // Navigate to add New User Screen
  const navigateToAddUser = () => {
    navigate('/user-management/user/add');
  };
  // Navigate to Detail Active User
  const navigateToDetailActive = (id: string) => {
    navigate(`/user-management/detail/active/${id.toString()}`);
  };
  // Navigate to Detail Deleted User
  const navigateToDetailDeleted = (id: string) => {
    navigate(`/user-management/detail/deleted/${id.toString()}`);
  };
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Showing Data List Logic
  * Handling for showing active or delete screen by Stepper Component
  * 0. Active
  * 1. Delete
  */
  const [step, setStep] = React.useState<number>(0);

  /* When after delete or add New User, params would have currentScreen on url params,
  * url format : user-management/:currentScreen
  */
  const { currentScreen } = useParams();
  // Changing current step depends on currentScreen params
  React.useEffect(() => {
    // Handle if hardcode wrong url
    if (currentScreen && currentScreen !== 'active') {
      if (currentScreen !== 'deleted') onNavigateBack();
      else setStep(1);
    } else {
      setStep(0);
    }
  }, [currentScreen]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get User List
  */
  // API for fetch data
  const { data: activeUserList, isLoading: userListLoad, refetch: refetchUserList } = useQuery(
    ['getAllByType', 'user', step],
    () => api.user.getAllByType(step),
  );

  // Refetch to delete or active list when step changed
  React.useEffect(() => {
    refetchUserList().catch((e) => console.log(e));
  }, [step]);

  // Manage data to have output like what we needed
  const listUser : UserListData[] = React.useMemo(() => {
    const userList = activeUserList?.data.data;
    if (userList) {
      return userList.map((result) => {
        const fullName = `${result.firstname} ${result.lastname}`;
        const {
          id, position, username,
        } = result;
        return {
          name: fullName,
          id: id.toString(),
          email: username,
          position,
        };
      });
    } return [];
  }, [activeUserList]);

  return {
    step,
    setStep,
    navigateToAddUser,
    listUser,
    userListLoad,
    navigateToDetailActive,
    navigateToDetailDeleted,
  };
}
export default useUsers;
